import React from 'react';
import {formatCurrency, trackClick} from '../util/util.js';
import adiTrack from '../util/adi_track.js'
import { ReCaptcha } from 'react-recaptcha-google'

const initialState = {
    'classifieds.attachment.text_attachment:21': "", // name
    'classifieds.attachment.text_attachment:22': "", // email
    'classifieds.attachment.text_attachment:23': "", // phone
    'classifieds.attachment.text_attachment:24': "", // comments
    'classifieds.attachment.text_attachment:25': "", // privacy policy checked
    'classifieds.attachment.text_attachment:1': "",  // community name
    'classifieds.attachment.text_attachment:7': "",  // community phone
    'classifieds.attachment.text_attachment:8': "",  // community email
    'classifieds.attachment.text_attachment:11': "", // community comments
    'classifieds.attachment.text_attachment:12': "", // community privacy policy checked
    nameError: "",
    emailError: "",
    privacyError: "",
    thanksDisplay: "none",
    formDisplay: "block",
    emailSent: false
}

const errorStyles = {
    color : 'red',
    fontSize: '11'
};

const affiliatePrivacyDisplay = {
    "al": "AL",
    "cleveland": "Cleveland",
    "gulflive": "GulfLive",
    "lehighvalleylive": "LehighValleyLive",
    "masslive": "MassLive",
    "nj": "NJ",
    "oregonlive": "OregonLive",
    "pennlive": "PennLive",
    "silive": "SILive",
    "syracuse": "Syracuse"
}

class HiddenFormInputs extends React.PureComponent {
    render() {
        const {item, isCommunity, affiliate, fullName} = this.props
        const lead_customer_id = (!!item.agent_marketing_level &&
                                    item.agent_marketing_level.toUpperCase() === 'ENHANCED' &&
                                    item.agent_email)
                ? item.agent_id : item.broker_id;
        const pmc_customer_id = item.property_management_id;
        const privatePartyEmail = (item.listing_email) ? 'true' : 'false';

        if (isCommunity) {
            return (
                <>
                <input type="hidden" name="tp" value={affiliate} />
                <input type="hidden" name="category" value="community" />
                <input type="hidden" name="detail_2014" value="true" />
                <input type="hidden" name="temp_type" value="detail" />
                <input type="hidden" name="finder" value="rent" />
                <input type="hidden" name="ad_id" value={item.ad_id} />

                <input type="hidden" name="classification" value="real estate" />
                <input type="hidden" name="custid" value="" />
                <input type="hidden" name="property" value={fullName + '.com'} />
                <input type="hidden" name="lead_recipient" value="listing_agent" />

                <input type="hidden" name="classifieds.ad_response.user_id" value="-1" />
                <input type="hidden" name="classifieds.ad_response.customer_id" value={pmc_customer_id} />
                <input type="hidden" name="classifieds.ad_response.status" value="New" />
                <input type="hidden" name="classifieds.ad_response.ad_id" value={item.ad_id} />
                <input type="hidden" name="classifieds.ad_response.created_by" value="mdApartments Lead" />

                <input type="hidden" name="classifieds.attachment.object_id:1" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:1" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:1" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:1" value="name" />
                <input type="hidden" name="classifieds.attachment.object_id:2" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:2" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:2" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:2" value="address" />
                <input type="hidden" name="classifieds.attachment.object_id:3" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:3" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:3" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:3" value="city" />
                <input type="hidden" name="classifieds.attachment.object_id:4" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:4" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:4" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:4" value="state" />
                <input type="hidden" name="classifieds.attachment.object_id:5" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:5" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:5" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:5" value="postal_code" />
                <input type="hidden" name="classifieds.attachment.object_id:6" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:6" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:6" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:6" value="country" />
                <input type="hidden" name="classifieds.attachment.object_id:7" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:7" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:7" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:7" value="phone" />
                <input type="hidden" name="classifieds.attachment.object_id:8" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:8" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:8" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:8" value="email" />
                <input type="hidden" name="classifieds.attachment.object_id:9" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:9" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:9" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:9" value="movein" />
                <input type="hidden" name="classifieds.attachment.object_id:10" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:10" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:10" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:10" value="lease_term" />
                <input type="hidden" name="classifieds.attachment.object_id:11" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:11" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:11" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:11" value="comments" />
                <input type="hidden" name="classifieds.attachment.object_id:12" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:12" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:12" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:12" value="privacy_policy_checked" />
                </>
            )
        } else {
            return (
                <>
                <input type="hidden" name="tp" value={affiliate} />
                <input type="hidden" name="actn" value="SEND" />
                <input type="hidden" name="category" value="AJAX broker agent mail" />
                <input type="hidden" name="privatePartyEmail" value={privatePartyEmail} />
                <input type="hidden" name="detail_2014" value="true" />
                <input type="hidden" name="temp_type" value="detail" />
                <input type="hidden" name="finder" value="buy" />
                <input type="hidden" name="ad_id" value={item.ad_id} />

                <input type="hidden" name="classification" value="real estate" />
                <input type="hidden" name="custid" value={lead_customer_id} />
                <input type="hidden" name="property" value={fullName + '.com'} />

                <input type="hidden" name="classifieds.attachment.object_id:21" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:21" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:21" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:21" value="Name" />

                <input type="hidden" name="classifieds.attachment.object_id:22" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:22" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:22" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:22" value="Email" />

                <input type="hidden" name="classifieds.attachment.object_id:23" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:23" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:23" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:23" value="Phone" />

                <input type="hidden" name="classifieds.attachment.object_id:24" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:24" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:24" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:24" value="Comments" />

                <input type="hidden" name="classifieds.attachment.object_id:25" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:25" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:25" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:25" value="PrivacyPolicyChecked" />

                <input type="hidden" name="resp_id" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.ad_response.ad_id" value={item.ad_id} />
                <input type="hidden" name="classifieds.ad_response.customer_id" value={lead_customer_id} />
                <input type="hidden" name="classifieds.ad_response.user_id" value="-5" />
                <input type="hidden" name="classifieds.ad_response.status" value="New" />
                <input type="hidden" name="classifieds.ad_response.created_by" value="mdRealestate Leads" />

                <input type="hidden" name="classifieds.attachment.object_id:1" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:1" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:1" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:1" value="Number" />
                <input type="hidden" name="classifieds.attachment.text_attachment:1" value={item.ad_number} />

                <input type="hidden" name="classifieds.attachment.object_id:2" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:2" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:2" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:2" value="House_Status" />
                <input type="hidden" name="classifieds.attachment.text_attachment:2" value={item.house_status} />

                <input type="hidden" name="classifieds.attachment.object_id:3" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:3" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:3" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:3" value="Beds" />
                <input type="hidden" name="classifieds.attachment.text_attachment:3" value={item.beds} />

                <input type="hidden" name="classifieds.attachment.object_id:4" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:4" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:4" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:4" value="Baths" />
                <input type="hidden" name="classifieds.attachment.text_attachment:4" value={item.baths} />

                <input type="hidden" name="classifieds.attachment.object_id:5" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:5" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:5" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:5" value="Price" />
                <input type="hidden" name="classifieds.attachment.text_attachment:5" value={formatCurrency(item.price) || ''} />

                <input type="hidden" name="classifieds.attachment.object_id:6" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:6" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:6" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:6" value="Zipcode" />
                <input type="hidden" name="classifieds.attachment.text_attachment:6" value={item.zipcode} />

                <input type="hidden" name="classifieds.attachment.object_id:7" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:7" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:7" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:7" value="Neighborhood" />
                <input type="hidden" name="classifieds.attachment.text_attachment:7" value={item.neighborhood} />

                <input type="hidden" name="classifieds.attachment.object_id:8" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:8" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:8" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:8" value="County" />
                <input type="hidden" name="classifieds.attachment.text_attachment:8" value={item.county} />

                <input type="hidden" name="classifieds.attachment.object_id:10" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:10" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:10" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:10" value="Internet_Address" />
                <input type="hidden" name="classifieds.attachment.text_attachment:10" value={item.internet_address} />

                <input type="hidden" name="classifieds.attachment.object_id:11" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:11" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:11" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:11" value="City" />
                <input type="hidden" name="classifieds.attachment.text_attachment:11" value={item.city} />

                <input type="hidden" name="classifieds.attachment.object_id:12" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:12" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:12" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:12" value="State" />
                <input type="hidden" name="classifieds.attachment.text_attachment:12" value={item.state} />

                <input type="hidden" name="classifieds.attachment.object_id:13" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:13" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:13" value="ad_site" />
                <input type="hidden" name="classifieds.attachment.name:13" value={fullName + '.com'} />
                <input type="hidden" name="classifieds.attachment.text_attachment:13" value={fullName + '.com'} />

                <input type="hidden" name="classifieds.attachment.object_id:14" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:14" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:14" value="ad_property" />
                <input type="hidden" name="classifieds.attachment.name:14" value={item.property} />
                <input type="hidden" name="classifieds.attachment.text_attachment:14" value={item.property} />
                </>
            )
        }
    }
}


class ContactForm extends React.Component {
    constructor (props) {
        super(props);
        this.state = initialState;
        const {streetAddress, item} = props;
       // console.log(props);
        const {city, state, zipcode, ad_number, web_id} = item;
        const idDisplay = (web_id || ad_number) ? ` (ID #${web_id || ad_number})` : '';
        this.state['message'] = `I am interested in ${streetAddress}, ${city}, ${state} ${zipcode}${idDisplay}.`;
        this.state['initialFocus'] = false;
        this.state['captchaData'] = null;
        this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
    }

    componentDidMount() {
        if (this.captchaDemo) {
            //console.log("started, just a second...")
            this.captchaDemo.reset();
        }

    }

    onLoadRecaptcha() {
        if (this.captchaDemo) {
            //console.log("CAPTCHA: onLoad");
            this.captchaDemo.reset();
        }
    }

    verifyCallback(recaptchaToken) {
        // Here you will get the final recaptchaToken!!!
        //console.log(recaptchaToken, "<= your recaptcha token")
        this.setState({captchaData: recaptchaToken});
    }

    handleChange = event => {
        this.setState ({[event.target.name]: event.target.value});
    }

    hash = (s) => {
        /* Simple hash function. */
        let a = 1, c = 0, h, o;
        if (s) {
            a = 0;
            /*jshint plusplus:false bitwise:false*/
            for (h = s.length - 1; h >= 0; h--) {
                o = s.charCodeAt(h);
                a = (a<<6&268435455) + o + (o<<14);
                c = a & 266338304;
                a = c!==0?a^c>>21:a;
            }
        }
        return String(a);
    };

    trackSubmitLead = (item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId) => {
        if (isCommunity) {
            fetch(reportingTrackingPath + ';pc=460', {mode: 'no-cors'});
        } else {
            fetch(reportingTrackingPath + ';pc=206', {mode: 'no-cors'});
            fetch(reportingTrackingPath + ';pc=214', {mode: 'no-cors'});
            if (trackingEnabled) {
                const dataProperty = item.property.toUpperCase();
                try {
                    if (item.listhub_key && listHubProviderId) {
                        const _lh = new window.ListHubTracker({provider: listHubProviderId, test: false});
                        _lh.submit('EMAIL_CLICKED', item.listhub_key);
                    }
                } catch(err) {console.log('listHub error' + err)}
                try {
                    if (typeof(window._LT) !== 'undefined' &&
                        window._LT !== null &&
                        !dataProperty.includes('ADPAY') &&
                        !!item.agent_id_attribute) {
                            window._LT._trackEvent(window._eventType.lead, item.ad_number, item.zipcode, item.agent_id_attribute);
                        }
                } catch(err) {console.log('listtrac error' + err)}
            }
        }
        adiTrack.event('realestate_temp_lead_form_submission');
    }

    validate = (isCommunity) => {
        let nameError = "";
        let emailError = "";
        let privacyError = "";
        let userNameField = 'classifieds.attachment.text_attachment:21';
        let emailNameField = 'classifieds.attachment.text_attachment:22';
        let privacyNameField = 'classifieds.attachment.text_attachment:25';
        if (isCommunity) {
            userNameField = 'classifieds.attachment.text_attachment:1';
            emailNameField = 'classifieds.attachment.text_attachment:8';
            privacyNameField = 'classifieds.attachment.text_attachment:12';
        }

        if (!this.state[userNameField]) {
            nameError = 'Name is required';
        }

        if (this.state[emailNameField].search(/^(\w([-._\w]*\w)*@(\w[-_\w]*\w\.)+\w{2,9})$/)) {
            emailError = 'Invalid Email';
        }

        if (!this.state[emailNameField]) {
            emailError = 'Email is required';
        }

        if (!this.state[privacyNameField]) {
            privacyError = 'Privacy agreement is required';
        }

        if (nameError || emailError || privacyError) {
            this.setState({nameError, emailError, privacyError});
            return false;
        }

        return true;
    }

    handleSubmit = (event, item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId) => {
        event.preventDefault();
        const isValid = this.validate(isCommunity);
        const trackSubmitLead = this.trackSubmitLead;
        if (isValid && !this.state.emailSent && this.state.captchaData) {
            const url = '//realestate.' + this.props.fullName + '.com/forge/data_entry';
            const formData = new FormData(event.target);
            let userNameField = 'classifieds.attachment.text_attachment:21';
            let emailNameField = 'classifieds.attachment.text_attachment:22';
            let phoneNameField = 'classifieds.attachment.text_attachment:23';
            let messageNameField = 'classifieds.attachment.text_attachment:24';
            let privacyNameField = 'classifieds.attachment.text_attachment:25';
            if (isCommunity) {
                userNameField = 'classifieds.attachment.text_attachment:1';
                emailNameField = 'classifieds.attachment.text_attachment:8';
                phoneNameField = 'classifieds.attachment.text_attachment:7';
                messageNameField = 'classifieds.attachment.text_attachment:11';
                privacyNameField = 'classifieds.attachment.text_attachment:12';
            }
            const userNameValue = this.hash(formData.get(userNameField));
            const emailNameValue = this.hash(formData.get(emailNameField));
            const phoneNameValue = this.hash(formData.get(phoneNameField));
            const messageNameValue = formData.get(messageNameField);
            const privacyNameValue = formData.get(privacyNameField);
            fetch(url, {
                method: "POST",
                body: formData
            }).then(function(response) {
                console.log('fetch response ' + JSON.stringify(response));
                trackSubmitLead(item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId);
                // TRACK: dp_contact_submit
                trackClick('dp_contact_submit', `dp_contact_submit_success: ${item.ad_id},field1:${userNameValue},field2:${emailNameValue},field3:${phoneNameValue},field4:${messageNameValue},field5:${privacyNameValue},recipient:morris`);
                console.log(`dp_contact_submit_success: ${item.ad_id},field1:${userNameValue},field2:${emailNameValue},field3:${phoneNameValue},field4:${messageNameValue},field5:${privacyNameValue}`);
            }).catch(function(err) {
	            console.log('fetch error ' + err);
                trackSubmitLead(item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId);
                console.log(`dp_contact_submit_error: ${item.ad_id},field1:${userNameValue},field2:${emailNameValue},field3:${phoneNameValue},field4:${messageNameValue},field5:${privacyNameValue}`);
            });
            //clear form
            this.setState({initialState, thanksDisplay: 'block', formDisplay: 'none', emailSent: 'true'});
        }
    }

    render() {
        const {item, affiliate, fullName, mode, isCommunity, reportingTrackingPath, trackingEnabled,
            listHubProviderId} = this.props
        let contactFormId = 'contact_form'
        let contactFormName = 'contact'
        let nameId = 'first_name'
        let emailId = 'email'
        let phoneId = 'end_user_phone'
        let messageId = 'p_messageID'
        let privacyId = 'privacy'
        let thanksId = 'thanks_id'
        if (mode === "mobile") {
            contactFormId = 'm_contact_form'
            contactFormName = 'm_contact'
            nameId = 'm_first_name'
            emailId = 'm_email'
            phoneId = 'm_end_user_phone'
            messageId = 'm_p_messageID'
            privacyId = 'm_privacy'
            thanksId = 'm_thanks'
        }
        let userNameField = 'classifieds.attachment.text_attachment:21';
        let emailNameField = 'classifieds.attachment.text_attachment:22';
        let phoneNameField = 'classifieds.attachment.text_attachment:23';
        let messageNameField = 'classifieds.attachment.text_attachment:24';
        let privacyNameField = 'classifieds.attachment.text_attachment:25';
        if (isCommunity) {
            userNameField = 'classifieds.attachment.text_attachment:1';
            emailNameField = 'classifieds.attachment.text_attachment:8';
            phoneNameField = 'classifieds.attachment.text_attachment:7';
            messageNameField = 'classifieds.attachment.text_attachment:11';
            privacyNameField = 'classifieds.attachment.text_attachment:12';
        }
        return(
            <div className="contact-form">
                <form
                    name={contactFormName}
                    id={contactFormId}
                    method="post"
                    style={{display: (this.state.formDisplay)}}
                    onFocus={() => {
                        if (!this.state.initialFocus) {
                            // TRACK: dp_contact_input
                            trackClick('dp_contact_input', `dp_contact_input_focused: ${item.ad_id}`);
                            this.setState({initialFocus: true});
                        }
                    }}
                    onSubmit={(event) => this.handleSubmit(event,
                                                            item,
                                                            isCommunity,
                                                            reportingTrackingPath,
                                                            trackingEnabled,
                                                            listHubProviderId)}
                    >
                    <HiddenFormInputs
                        item={item}
                        isCommunity={isCommunity}
                        affiliate={affiliate}
                        fullName={fullName} />
                    <input
                        className="long_field"
                        tabIndex="1"
                        id={nameId}
                        name={userNameField}
                        type="text"
                        placeholder="Your name"
                        value={this.state[userNameField]}
                        onChange={(event) => this.handleChange(event)}
                        />
                    <div style={errorStyles}>{this.state.nameError}</div>
                    <input
                        className="long_field"
                        tabIndex="2"
                        id={emailId}
                        name={emailNameField}
                        type="text"
                        placeholder="Your email address"
                        value={this.state[emailNameField]}
                        onChange={(event) => this.handleChange(event)}
                        />
                    <div style={errorStyles}>{this.state.emailError}</div>
                    <input
                        className="long_field phone_num"
                        tabIndex="3"
                        id={phoneId}
                        name={phoneNameField}
                        type="text"
                        placeholder="Your phone number (optional)"
                        value={this.state[phoneNameField]}
                        onChange={(event) => this.handleChange(event)}
                        />
                    <div style={errorStyles}>{this.state.phoneError}</div>
                    <textarea
                        name={messageNameField}
                        id={messageId}
                        className="long_field"
                        tabIndex="4"
                        value={this.state.message}
                        onChange={(event) => {
                            this.setState({message: event.target.value})
                            }}
                    >
                    </textarea>
                    <div className="priv-policy">
                        <input
                            className="featuresCheckbox"
                            type="checkbox"
                            name={privacyNameField}
                            id={privacyId}
                            checked={this.state[privacyNameField]}
                            onChange={(event) => {
                                this.setState({[privacyNameField]: event.target.checked})
                            }}
                        />
                        <label>I agree to {affiliatePrivacyDisplay[fullName]}.com's <a href={"https://www." + fullName + ".com/privacy-policy/"} target="_blank" >Privacy Policy</a></label>
                    </div>
                    <div style={errorStyles}>{this.state.privacyError}</div>
                    {this.state.captchaData ?
                        <button href="#" tabIndex="5">
                            Contact {isCommunity ? 'Us' : 'Realtor'}
                        </button>
                        :
                        <ReCaptcha
                            ref={(el) => {this.captchaDemo = el;}}
                            size="normal"
                            data-theme="dark"
                            render="explicit"
                            sitekey="6Le50KYZAAAAADUEO0_Flf8F-Ho-L_vy_8mO1GUz"
                            onloadCallback={this.onLoadRecaptcha}
                            verifyCallback={this.verifyCallback}
                        />
                    }
                </form>

                <div id={thanksId} className="thanks" style={{display: (this.state.thanksDisplay)}}>
                    <h3>THANK YOU</h3>
                    <p>Thank you, your message has been sent.</p>
                    <div style={{display: 'none'}}>
                        <h4>Next Step:</h4>
                        <p>Make sure you know your credit score before renting a home. Check it here for free, and be prepared as you look for more homes.</p>
                        <div className="before_buy">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gofreecredit.com/r/5595c49299/?subid=thankyousale"><img src="//static.advance.net/static/classifieds/realestate/details/img/btn_before_buy.png" alt="check your credit"/></a>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default ContactForm;